import { useEffect, useState } from "react";
import "../styles/componentStyles/UIComponent.scss";
import { AudioAsset } from "../webar-core/framework/store/AssetSlice";
import { useStore } from "../webar-core/framework/store/Store";
import {
  trackCTAClick,
  trackShareClick,
} from "../webar-core/framework/utils/gtag";
/**
 * UI Component
 * Responsible for all the experience 2D UI
 * @returns
 */
export const UIComponent = (props: any) => {
  const [animateGems, setAnimateGems] = useState(false);
  const [ctaButtonClicked, setCtaButtonClicked] = useState(false);
  const [shareButtonClicked, setShareButtonClicked] = useState(false);

  useEffect(() => {
    if (props.showUI) {
      setTimeout(() => {
        // Wait 2 seconds for the game UI animation
        setAnimateGems(true);
      }, 3000);
    }

    if (shareButtonClicked) {
      const shareData = {
        title: "The Glenlivet",
        text: "Enter The Augmented Reality Glenlivet Sample Room and experience a new dimension of taste",
        url: window.location.href,
      };

      navigator.share(shareData);
      setShareButtonClicked(false);
    }
  }, [props.showUI, shareButtonClicked]);

  return (
    <div style={{ display: props.showUI ? "block" : "none" }}>
      <div id="gameUIWrapper">
        <div id="gameUI" className={props.showUI ? "animateIn" : ""}>
          <div
            id="shareIcon"
            className={`${shareButtonClicked ? "active" : ""}`}
            onClick={() => {
              (
                useStore
                  .getState()
                  .assets.get("shareTapSoundEffect") as AudioAsset
              ).play();
              trackShareClick();
              setShareButtonClicked(true);
            }}
          >
            <img
              className="highlight"
              src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/inGame/highlight.png"
              alt=""
            />
            <img
              src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/inGame/shareIcon.png"
              alt=""
            />
          </div>
          <div
            id="gems"
            className={`${animateGems ? "animateIn" : ""} ${
              props.gemsFinal ? "collected" : ""
            }`}
          >
            <img
              className="gemsBackground"
              src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/inGame/gemsBackground.png"
              alt=""
            />
            <div id="gem1" className={props.gemsFound >= 1 ? "active" : ""}>
              <img
                src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/inGame/gem.png"
                alt=""
              />
              <img
                src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/inGame/gemActive.png"
                alt=""
              />
            </div>
            <div id="gem2" className={props.gemsFound >= 2 ? "active" : ""}>
              <img
                src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/inGame/gem.png"
                alt=""
              />
              <img
                src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/inGame/gemActive.png"
                alt=""
              />
            </div>
            <div id="gem3" className={props.gemsFound >= 3 ? "active" : ""}>
              <img
                src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/inGame/gem.png"
                alt=""
              />
              <img
                src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/inGame/gemActive.png"
                alt=""
              />
            </div>
            <div id="gem4" className={props.gemsFound >= 4 ? "active" : ""}>
              <img
                src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/inGame/gem.png"
                alt=""
              />
              <img
                src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/inGame/gemActive.png"
                alt=""
              />
            </div>
            <div id="gem5" className={props.gemsFound >= 5 ? "active" : ""}>
              <img
                src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/inGame/gem.png"
                alt=""
              />
              <img
                src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/inGame/gemActive.png"
                alt=""
              />
            </div>
            <div id="gem6" className={props.gemsFound >= 6 ? "active" : ""}>
              <img
                src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/inGame/gem.png"
                alt=""
              />
              <img
                src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/inGame/gemActive.png"
                alt=""
              />
            </div>
          </div>
          <div
            id="ctaIcon"
            className={`${ctaButtonClicked ? "active" : ""}`}
            onClick={() => {
              (
                useStore
                  .getState()
                  .assets.get("shoppingTapSoundEffect") as AudioAsset
              ).play();
              trackCTAClick();
              setCtaButtonClicked(true);
              window.location.href =
                "https://www.theglenlivet.com/en/the-shop/";
            }}
          >
            <img
              className="highlight"
              src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/inGame/highlight.png"
              alt=""
            />
            <img
              src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/inGame/shoppingBagIcon.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};
